import { createFileRoute, Link } from '@tanstack/react-router'
import { DollarSignIcon } from 'lucide-react'
import { useBalance } from '@/domains/balance/hooks/useBalance'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { useUserQuery } from '@/domains/user/queries'
import { CopyButton } from '@/components/CopyButton'
import { AvailableGamesTable } from '@/domains/game/components/AvailableGamesTable'
import { Button } from '@/components/ui/button'

export const Route = createFileRoute('/')({ component: Home })

function Home() {
  const { data: user } = useUserQuery()
  const balance = useBalance()

  return (
    <div className="px-4 lg:px-8">
      {user?.deposit_address && balance === 0 && (
        <Alert variant="default">
          <DollarSignIcon />
          <AlertTitle>Fund your account</AlertTitle>
          <AlertDescription>
            <span>
              Before you start playing, you need to fund your account by sending{' '}
              <strong>USDC</strong> via <strong>Base</strong> to the wallet
              address below. Once sent, wait a few minutes for your balance to
              be reflected.
            </span>
          </AlertDescription>
          <AlertDescription className="mt-2 flex items-center">
            <CopyButton text={user.deposit_address} />
            <Button variant="link" asChild>
              <a
                href="https://youtube.com/shorts/aqlc36VmS_s?si=dNeTvedAFxBRivkL"
                target="_blank"
              >
                Video tutorial
              </a>
            </Button>
          </AlertDescription>
        </Alert>
      )}
      <div className="flex flex-col gap-4 mt-4">
        <div className="flex flex-col gap-1">
          <h1 className="font-PPMondwest text-3xl md:text-4xl md:w-2/4">
            Combining the best player experience with the lowest rake in poker.
          </h1>
          <p className="text-muted-foreground md:text-[15px]">
            Texas no-limit hold'em poker with a 1% rake.
          </p>
        </div>
        <div>
          <Button variant="steelGold" className="w-fit" asChild>
            {user ? (
              <Link to="/game/new">Create game</Link>
            ) : (
              <Link to="/signup">Sign up</Link>
            )}
          </Button>

          <Button variant="link" className="font-light" asChild>
            <a href="https://discord.gg/UQaFPRgTps" target="_blank">
              Community
            </a>
          </Button>
        </div>
      </div>
      <AvailableGamesTable />
    </div>
  )
}
